// extracted by mini-css-extract-plugin
module.exports = {"component":"SkipNavigationLink_component__qLA4b"};